import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
// @ts-ignore
import { ApiClient } from '@nplus.tech/ktwidget-client';
import { ModalModule } from '../../../core/modal/modal.module';
import { SharedModule } from '../../../shared/shared.module';
import { PaymentAccountModalService } from '../payment-account-modal.service';

@Component({
  selector: 'tax-supplement',
  templateUrl: './supplement.component.html',
  styleUrls: ['./supplement.component.sass'],
  standalone: true,
  imports: [
    ModalModule,
    NgIf,
    TranslateModule,
    FormsModule,
    SharedModule,
  ],
})

export class SupplementComponent {
  @Input() notification?: string;
  @Input() billingAccountNumber: string = '';
  payment = '';

  constructor(private paymentAccountModalService: PaymentAccountModalService) {}

  openKtPayWidget(): void {
    const cryptoObj = window.crypto;
    const uuid = () => (`${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`).replace(
      /[018]/g,
      (c: any) => (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16),
    );
    const transaction = new ApiClient(
      'O4NaONTvKajnLTboqTDqHfHLMHRfxJGanp2ly1QlHy8=', // app_key - Публичный ключ
      '59d1f15378998ad17c37ed9d490846ee', // app_id - Идентификатор приложения
      false, // test_mode - флаг изменения работы виджета на тестовый и на боевой режим true = test, false = production
    );
    transaction.createTransaction({
      order_id: uuid, // Уникально для каждой транзакции
      amount: this.payment,
      type: 'service',
      service: {
        service_id: 1,
        contract_value: `23-${this.billingAccountNumber}`,
      },
      callback_back_url: 'https://org.oofd.kz/#/main/account',
      description: 'Оплата за услугу ОФД',
    });
  }

  closeModal(): void {
    this.paymentAccountModalService.openPaymentMethodModal(this.billingAccountNumber);
  }
}
